import { jsx as a } from "react/jsx-runtime";
import c from "@mui/material/SvgIcon";
import * as o from "react";
import { forwardRef as l } from "react";
const m = (e) => /* @__PURE__ */ o.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "6 6 19.61 20", ...e }, /* @__PURE__ */ o.createElement("path", { fill: "currentColor", d: "M25.329 23.514a.97.97 0 0 0 0-1.362l-2.576-2.613c.875-1.491.692-3.444-.574-4.728a3.79 3.79 0 0 0-5.418 0 3.926 3.926 0 0 0 0 5.497 3.8 3.8 0 0 0 2.71 1.138c.662 0 1.32-.188 1.91-.535l2.566 2.603a.97.97 0 0 0 1.381 0m-7.682-4.104a2.62 2.62 0 0 1-.756-1.85c0-.698.269-1.356.756-1.85a2.54 2.54 0 0 1 1.823-.767c.69 0 1.337.273 1.825.767.487.494.755 1.152.755 1.85a2.62 2.62 0 0 1-.756 1.85 2.54 2.54 0 0 1-1.824.767 2.55 2.55 0 0 1-1.823-.767" }), /* @__PURE__ */ o.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6 10.157a1.79 1.79 0 0 1 1.8-1.782h2.998C10.798 7.063 11.872 6 13.197 6s2.399 1.063 2.399 2.375h2.999c.477 0 .934.188 1.272.522.234.232.397.522.475.836v2.802a5 5 0 0 0-.934-.091c-2.778 0-5.03 2.285-5.03 5.103 0 2.819 2.252 5.104 5.03 5.104.32 0 .631-.034.934-.092v2.085A1.8 1.8 0 0 1 18.598 26H7.796a1.795 1.795 0 0 1-1.77-1.478V10.429A1.4 1.4 0 0 1 6 10.157m7.197-2.672c-.497 0-.9.398-.9.89s.403.891.9.891.9-.399.9-.89a.907.907 0 0 0-.9-.891", clipRule: "evenodd" })), f = /* @__PURE__ */ l(({ size: e = "inherit", sx: t, ...r }, n) => {
  const i = typeof t == "function" ? t : {
    fontSize: e,
    ...t
  };
  return /* @__PURE__ */ a(c, {
    ...r,
    ref: n,
    component: m,
    inheritViewBox: !0,
    sx: i
  });
});
f.displayName = "svg_review";
export {
  f as default
};
